<h3 mat-dialog-title [innerHTML]="data.title"></h3>
<mat-dialog-content>
    <span class="hint" [innerHTML]="data.hint"></span>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="onCancel()">{{ 'CANCEL' | transloco }}</button>
    <button mat-flat-button mat-dialog-close color="primary" (click)="onSubmit()">{{ 'SUBMIT' | transloco }}</button>
</mat-dialog-actions>
